import { useSubscribedState } from 'nordic/page/store';

export const useStaticProps = () => useSubscribedState()?.staticProps;
